import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchFieldComponent } from '@modules/components/search-field/search-field.component';
import { ReferenceFilter } from '@modules/filter/directives/reference-filter.directive';
import { provideFilterItem } from '@modules/filter/utils/token';
import { FilterBean, FilterType } from '@type/filter.type';
import { combineLatest, filter, map, switchMap } from 'rxjs';

const DEFAULT_FILTER = new FilterBean(FilterType.Reference);

@Component({
  selector: 'app-f-reference',
  imports: [SearchFieldComponent, MatCheckboxModule, FormsModule],
  providers: [provideFilterItem(FReferenceComponent)],
  templateUrl: './f-reference.component.html',
  styleUrl: './f-reference.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FReferenceComponent extends ReferenceFilter<FilterBean> {
  dictionary = toSignal(
    combineLatest([toObservable(this.row), toObservable(this.opened), toObservable(this.query)]).pipe(
      filter(([model, open]) => !!model && open),
      switchMap(([{ dictionaryModel }, _, query]) => this.fds.getDictionary(dictionaryModel, query)),
      map(({ dict }) => dict),
    ),
    { initialValue: [] },
  );

  count = computed(() => this.viewDictionary().length + +this.showCheckboxForEmptyValue);

  defaultFilter(): FilterBean {
    return { ...DEFAULT_FILTER, value: [], name: this.filter?.name || '', model: this.filter?.model || '' };
  }
}
